import React from "react";
import styles from "./SpeakerCard.module.css";
import { getPictureHandlerUrl } from "../../../../helpers/Utils";
import Utils from "../../../Utils";

function SpeakerCard({ speaker, isSelected, toggleSelection }) {
  const { firstName, lastName, title, country, pictureId } = speaker;
  const profilePicture = getPictureHandlerUrl(pictureId);

  const plainTitle = Utils.removeHtml(title);
  const renderedTitle =
    plainTitle?.length > 30 ? `${plainTitle?.slice(0, 30)}...` : plainTitle;

  return (
    <div
      className={styles.speakerCard}
      style={isSelected ? { backgroundColor: "#d6fdd6" } : {}}
      onClick={() => toggleSelection(speaker)}
    >
      <div className={styles.profilePicture}>
        <img src={profilePicture} alt="profile" />
      </div>
      <div className={styles.information}>
        <span className={styles.fullName}>{`${lastName}, ${firstName}`}</span>
        <span
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: renderedTitle }}
        ></span>
        <span className={styles.country}>{country}</span>
      </div>
    </div>
  );
}

export default SpeakerCard;
